import moment from 'moment';

export const columns = [
  {
    name: 'Fecha',
    sortable: false,
    minWidth: '120px',
    selector: (row) => row.createdAt,
    cell: (row) => (
      <div style={{ fontSize: 12 }}>
        {moment(row.createdAt).format('DD/MM/YYYY, hh:mm a')}
      </div>
    )
  },
  {
    name: 'PORTADA',
    sortable: false,
    minWidth: '110px',
    selector: (row) => row.road.cover,
    cell: (row) => <img width={45} src={row.road.cover} />
  },
  {
    name: 'NOMBRE',
    sortable: true,
    minWidth: '200px',
    sortField: 'name',
    selector: (row) => row.road.name,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder">{row.road.name}</span>
        </div>
      </div>
    )
  },
  {
    name: 'PORCENTAJE',
    minWidth: '150px',
    sortable: false,
    cell: (row) => (
      <div className="progress" style={{ width: '100%', height: 7 }}>
        <div
          id={row._id}
          className="progress-bar"
          role="progressbar"
          style={{
            background: '#4DFF84',
            width: `${(row.currentEpisode * 100) / row.road.episodes.length}%`
          }}
          aria-valuenow={
            (row.currentEpisode * 100) / row.road.episodes.length || 0
          }
          aria-valuemin={0}
          aria-valuemax={100}
        ></div>
      </div>
    )
  },
  {
    name: 'COMPLETADOS',
    minWidth: '150px',
    sortable: false,
    sortField: 'completed',
    cell: (row) => (
      <span className="text-capitalize">
        {/* {((row.currentEpisode / row.road.episodes.length) * 100).toFixed(0)}% */}
        {row.completed
          ? '100'
          : Math.floor((row.currentEpisode * 100) / row.road.episodes.length)}
        %
      </span>
    )
  }
];
